$primary: #82bc44;
$border: #eaeaea;
$text: #333;
$muted: #666;

.modalOverlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.modalContent {
	background: #fff;
	padding: 1rem;
	border-radius: 8px;
	max-width: 90%;
	max-height: 90%;
	overflow: auto;
	position: relative;
	display: flex;
	flex-direction: column;
}

.titleBar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid $border;
	padding-bottom: 0.5rem;
	margin-bottom: 1rem;
	position: sticky;
	top: 0;
	background: #fff;
	z-index: 1;
}

.titleIcon {
	color: $primary;
	margin-right: 0.5rem;
}

.titleText {
	flex-grow: 1;
	font-size: 1.25rem;
	color: $text;
	margin: 0;
}

.closeIcon {
	cursor: pointer;
	color: $muted;
	transition: color 0.2s ease;

	&:hover {
		color: $text;
	}
}

.tableWrapper {
	overflow-x: auto;
}

.table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 1rem;

	th,
	td {
		padding: 0.5rem;
		border: 1px solid $border;
		vertical-align: middle;
	}

	th {
		background: #f9f9f9;
		text-align: left;
		font-weight: 600;
		color: $text;
	}

	.right {
		text-align: right;
	}

	.row:nth-child(even) {
		background: #fafafa;
	}
}
